import { create } from 'zustand';

import { Staff } from '@/features/companies/types';

export interface UserAuthInfo {
  user: Staff | null;
  setUserAuthInfo: (user: Staff | null) => void;
}

export const useAuth = create<UserAuthInfo>((set) => ({
  user: null,
  setUserAuthInfo: (user: Staff | null) => set({ user }),
}));
